<template>
  <div>
    <div class="modal-content committee-modal">
      <div class="modal-header" style="border-bottom: unset">
        <button
          type="button"
          class="close close-modal-button"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-header">
        <div class="modal-title w-100 d-flex justify-content-between h5">
          <div>{{ event.title }}</div>
          <div>
            <span>{{ event.date_start }} </span>-
            <span
              v-if="
                new Date(event.date_start).toDateString() ==
                  new Date(event.date_end).toDateString()
              "
              >{{ new Date(event.date_end).toLocaleTimeString() }}
            </span>
            <span v-else> {{ event.date_end }}</span>
          </div>
        </div>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between">
              <div class="aanwezig d-flex">
                <label for="attend" class="switch">
                  <input
                    @change="updateWillAttend()"
                    v-model="willAttend"
                    type="checkbox"
                    id="attend"
                  />
                  <span class="slider round"></span>
                </label>
                <p class="ml-2 pt-1">Aanwezig</p>
                &nbsp;
              </div>
              <div class="address" v-if="event.address && event.address != ''">
                <b>Adres: </b><span>{{ event.address }}</span>
              </div>
            </div>
          </div>
          <div
            class="col-12"
            v-if="event.eventtype && event.eventtype.absense == 1"
          >
            <div class="table">
              <table class="">
                <thead>
                  <tr>
                    <th>Absentie opgenomen op</th>
                    <th>Absentie bijgewerkt op</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ event.attandance_filled }}</td>
                    <td>{{ event.attandance_updated }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="col-12 mt-4" v-if="event.remarks && event.remarks.length">
            <h6>Opmerking</h6>
            <p v-html="event.remarks"></p>
          </div>
          <div
            class="col-12"
            v-if="event.description && event.description.length"
          >
            <h6>Omschrijving</h6>
            <p v-html="event.description"></p>
          </div>
          <div class="col-12">
            <h6>Informatie</h6>
            <ul>
              <li v-for="(grp, key) in event.itemgroups" :key="key">
                <router-link :to="`/itemgroups/${grp.id}/${grp.title_slug}`">{{
                  grp.title
                }}</router-link>
              </li>
            </ul>
          </div>
          <div class="col-lg-12">
            <button data-dismiss="modal" class="btn-dark float-right mt-3">
              Sluiten
            </button>
            <button @click="editEvent" class="btn-dark float-right mt-3">
              Bewerken
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- EVENT MODAL -->
    <!--       Event modal start-->
    <div
      class="modal fade"
      id="eventModal1"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" style="min-width: 999px">
        <event-form
          :key="'from_open' + forceUpdateKey"
          :event="event"
          :eventtypes="eventtypes"
        ></event-form>
      </div>
    </div>
  </div>
</template>

<script>
import EventForm from "./event_form.vue";
import moment from "moment";
import { mapState, mapActions } from "vuex";

export default {
  components: { EventForm },
  name: "EventDetails",
  props: {
    event: {},
    eventtypes: null,
    settings: {},
  },
  watch: {
    event: function(newVal) {
      if (newVal.attend) {
        this.willAttend = newVal.attend.pivot.attend == 1 ? true : false;
      }
    },
  },
  data() {
    return {
      committees: [],
      create_event: {},
      errormsg: "",
      eventtype_config: null,
      event_selected_committees: [],
      forceUpdateKey: 0,
      willAttend: false,
    };
  },
  computed: {
    ...mapState({
      selectedMembers: (state) => state.selectedMembers,
    }),
  },
  methods: {
    ...mapActions({
      displayNotification: "auth/displayNotification",
    }),
    moment: function() {
      return moment();
    },
    updateWillAttend() {
      this.$store
        .dispatch("post", {
          endpoint: "api/v1/event-attend",
          details: {
            event_id: this.event.id,
            user_id: 1,
            attend: this.willAttend ? 1 : 0,
          },
        })
        .then((data) => {
          console.log(data);
          this.displayNotification({
            type: "success",
            title: "Success",
            message: `${this.willAttend ? "Aangemeld" : "Afgemeld"}`,
            id: Math.round(Math.random() * 999),
            autoDismiss: true,
            interval: 2000,
          });
          this.$emit("triggerGetEvent");
        })
        .catch((error) => {
          console.log(error.request);
        });
    },
    editEvent() {
      this.forceUpdateKey++;
      window.$("#eventModal1").modal("show");
    },
    createEvent() {
      this.errormsg = "";
      if (!this.create_event.date_start) {
        this.errormsg = "Please select a start date";
        return false;
      }
      var selected_committee_ids = this.committees
        .filter((d) => d.selected)
        .map((d) => d.id);
      var selected_members = this.selectedMembers.map((d) => d.id);
      var event = this.create_event;
      //selected_committee_ids.push(this.id);

      var formData = new FormData();
      formData.append("title", event.title);
      formData.append("description", event.description ?? "");
      formData.append("eventtype_id", event.eventtype ?? "");
      formData.append("active", event.active);
      formData.append("public", event.public);
      formData.append("address", event.address);
      formData.append(
        "selected_committees",
        JSON.stringify(selected_committee_ids)
      );
      formData.append("selected_members", JSON.stringify(selected_members));
      formData.append("date_start", event.date_start);
      formData.append("date_end", event.date_end ?? "");
      formData.append("_method", "PUT");

      let url = this.create_event.id
        ? "api/v1/events/" + this.create_event.id
        : "api/v1/events";

      this.$store
        .dispatch("post", {
          endpoint: url,
          details: formData,
        })
        .then((data) => {
          window.location.reload();
          console.log(data);
        })
        .catch((error) => {
          console.log(error.request);
        });
    },
    eventtypeSelected() {
      var id = this.create_event.eventtype;
      var eventtype = this.eventtypes.find((d) => d.id == id);
      if (eventtype) {
        var settings = JSON.parse(eventtype.settings);
        if (settings.reoccurence_config) {
          var config = settings.reoccurence_config;
          this.eventtype_config = config;
          this.create_event.date_start = config.start_date;
          this.create_event.date_end = config.end_date;

          return false;
        }
        this.eventtype_config = null;
        this.create_event.date_start = null;
        this.create_event.date_end = null;
      }
    },
  },
  filters: {
    formatDate(value) {
      return moment(new Date(value)).format("DD-MM-YYYY HH:mm");
    },
  },
  created() {
    this.$store.dispatch("get", "api/v1/committees-all").then((data) => {
      this.committees = data.data.data;
    });
  },
};
</script>

<style scoped>
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: green;
}

input:focus + .slider {
  box-shadow: 0 0 1px green;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
